module.exports = __webpack_public_path__ + "media/images/flags/1x1/sle-bd7033839015655cad347849708ef142.svg";